"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allRowSizes = void 0;
exports.allRowSizes = [
    "compact",
    "medium",
    "large",
    "extra-large",
    "auto",
];
